import React, { useState, useEffect } from 'react';
import { Wrench, Clock, Unlock, Loader2 } from 'lucide-react';
import { motion } from 'framer-motion';
import { Link, useNavigate } from 'react-router-dom';
import api from '../services/api';

const MaintenancePage = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkMaintenance = async () => {
      try {
        const response = await api.get('/maintenance/status');
        if (!response.data.maintenance_mode) {
          // Maintenance désactivée, rediriger vers l'accueil
          navigate('/', { replace: true });
        }
      } catch (err) {
        // En cas d'erreur, rediriger vers l'accueil
        navigate('/', { replace: true });
      } finally {
        setLoading(false);
      }
    };
    
    checkMaintenance();
  }, [navigate]);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0A0A0B] flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-[#FF6B35]" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0A0A0B] flex items-center justify-center px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-lg w-full text-center"
      >
        {/* Logo */}
        <div className="mb-8">
          <h1 className="text-3xl sm:text-4xl font-bold text-[#FF6B35]">IPTV4KFR</h1>
        </div>

        {/* Icon */}
        <div className="mb-8">
          <div className="inline-flex items-center justify-center w-24 h-24 sm:w-32 sm:h-32 bg-[#FF6B35]/10 rounded-full mb-6">
            <Wrench className="h-12 w-12 sm:h-16 sm:w-16 text-[#FF6B35] animate-pulse" />
          </div>
        </div>

        {/* Message */}
        <div className="bg-[#1A1A1D] rounded-xl p-6 sm:p-8 border border-[#3A3A3D]">
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-4">
            Site en maintenance
          </h2>
          <p className="text-[#B8B8BA] text-sm sm:text-base mb-6">
            Nous effectuons actuellement des travaux de maintenance pour améliorer votre expérience. 
            Le site sera de nouveau accessible très prochainement.
          </p>
          
          <div className="flex items-center justify-center gap-2 text-[#FFB800]">
            <Clock className="h-5 w-5" />
            <span className="text-sm">Revenez bientôt !</span>
          </div>
        </div>

        {/* Contact */}
        <p className="mt-6 text-[#6B6B6E] text-sm">
          Pour toute urgence, contactez-nous à{' '}
          <a href="mailto:contact@iptv4kfr.fr" className="text-[#FF6B35] hover:underline">
            contact@iptv4kfr.fr
          </a>
        </p>

        {/* Admin access */}
        <div className="mt-8 pt-6 border-t border-[#3A3A3D]">
          <Link
            to="/maintenance/exit"
            className="inline-flex items-center space-x-2 text-[#B8B8BA] hover:text-[#FFB800] transition-colors text-sm"
          >
            <Unlock className="h-4 w-4" />
            <span>Accès administrateur</span>
          </Link>
        </div>
      </motion.div>
    </div>
  );
};

export default MaintenancePage;
